import React from 'react';

const RateContext = React.createContext([]);

export const RateProvider = props => <RateContext.Provider value={React.useState(false)} {...props} />;

export const useRate = () => React.useContext(RateContext);



// WEBPACK FOOTER //
// ./src/providers/rate.provider.js